<template>
  <div>
    <table>
      <tr>
        <td>ID:</td>
        <td>{{ partner.id }}</td>
      </tr>
      <tr>
        <td>Name:</td>
        <td><input type="text" v-model="name"/></td>
      </tr>
      <tr>
        <td>Company name:</td>
        <td><input type="text" min="0" v-model="company_name"/></td>
      </tr>
      <tr>
        <td>Company address:</td>
        <td><input type="text" min="0" v-model="company_address"/></td>
      </tr>
      <tr>
        <td>Company country:</td>
        <td><input type="text" min="0" v-model="company_country"/></td>
      </tr>
      <tr>
        <td>Contact person name:</td>
        <td><input type="text" min="0" v-model="contact_person_name"/></td>
      </tr>
      <tr>
        <td>Contact person position:</td>
        <td><input type="text" min="0" v-model="contact_person_position"/></td>
      </tr>
      <tr>
        <td>Contact person email:</td>
        <td><input type="text" min="0" v-model="contact_person_email"/></td>
      </tr>
      <tr>
        <td>Contact person phone number:</td>
        <td><input type="text" min="0" v-model="contact_person_phonenumber"/></td>
      </tr>
    </table>
    <button @click="cancel()">Cancel</button>
    <button @click="save()">Save</button>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

td input {
    min-width: 10px;
    max-width: 100%;
    width: 100%;
}

</style>

<script>
export default {
  props: {
    partner: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      name: this.partner.name,
      company_name: this.partner.company_name,
      company_address: this.partner.company_address,
      company_country: this.partner.company_country,
      contact_person_name: this.partner.contact_person_name,
      contact_person_position: this.partner.contact_person_position,
      contact_person_email: this.partner.contact_person_email,
      contact_person_phonenumber: this.partner.contact_person_phonenumber
    }
  },
  watch: {
    partner () {
      this.name = this.partner.name
      this.company_name = this.partner.company_name
      this.company_address = this.partner.company_address
      this.company_country = this.partner.company_country
      this.contact_person_name = this.partner.contact_person_name
      this.contact_person_position = this.partner.contact_person_position
      this.contact_person_email = this.partner.contact_person_email
      this.contact_person_phonenumber = this.partner.contact_person_phonenumber
    }
  },
  methods: {
    cancel () {
      this.name = this.partner.name
      this.company_name = this.partner.company_name
      this.company_address = this.partner.company_address
      this.company_country = this.partner.company_country
      this.contact_person_name = this.partner.contact_person_name
      this.contact_person_position = this.partner.contact_person_position
      this.contact_person_email = this.partner.contact_person_email
      this.contact_person_phonenumber = this.partner.contact_person_phonenumber
    },
    save () {
      var params = {}
      if (this.name !== this.partner.name) params['name'] = this.name
      if (this.company_name !== this.partner.company_name) params['company_name'] = this.company_name
      if (this.company_address !== this.partner.company_address) params['company_address'] = this.company_address
      if (this.company_country !== this.partner.company_country) params['company_country'] = this.company_country
      if (this.contact_person_name !== this.partner.contact_person_name) params['contact_person_name'] = this.contact_person_name
      if (this.contact_person_position !== this.partner.contact_person_position) params['contact_person_position'] = this.contact_person_position
      if (this.contact_person_email !== this.partner.contact_person_email) params['contact_person_email'] = this.contact_person_email
      
      if (this.contact_person_phonenumber !== this.partner.contact_person_phonenumber)
        params['contact_person_phonenumber'] = this.contact_person_phonenumber

      this.$store.dispatch('updatePartner', {
        partner: this.partner, 
        params: params
      })
    }
  }
}
</script>
